export default __webpack_public_path__ + "media/images/features/saga/ogp-06ceec78bb77a7ef9b0fc907a135b318.jpg";